export default __webpack_public_path__ + "static/media/validateEcardOTP@2x.d3bc01ff.png";